// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1aiqo","productName":"Table_productName__3e_6W"};